import { useState } from 'react';
import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { useSetUserDecisionV2Mutation } from '../../../__generated__/chirp/com/hubspot/ai/context/mining/rpc/TranscriptPropertyUpdateSuggestionsService.hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MilestoneSuggestionActions({
  suggestions,
  onResolved,
  onError
}) {
  const [pendingDecision, setPendingDecision] = useState(null);
  const [setUserDecision, {
    error
  }] = useSetUserDecisionV2Mutation();
  const handleDecision = async decisionStatus => {
    setPendingDecision(decisionStatus);
    try {
      const suggestionPromises = suggestions.map(suggestion => {
        return setUserDecision({
          variables: {
            runId: suggestion.runId,
            objectTypeId: suggestion.targetObjectTypeId,
            objectId: suggestion.targetObjectId,
            suggestionDecisionInputs: [{
              propertyName: suggestion.propertyName,
              decisionStatus
            }]
          }
        });
      });
      const results = await Promise.allSettled(suggestionPromises);
      const successfulSuggestions = [];
      const failedSuggestions = [];
      results.forEach((result, index) => {
        var _result$value$errors;
        const isFailure = result.status === 'rejected' || !!((_result$value$errors = result.value.errors) !== null && _result$value$errors !== void 0 && _result$value$errors.length);
        (isFailure ? failedSuggestions : successfulSuggestions).push(suggestions[index]);
      });
      if (successfulSuggestions.length > 0) {
        await (onResolved === null || onResolved === void 0 ? void 0 : onResolved(successfulSuggestions, decisionStatus));
      }
      if (failedSuggestions.length > 0) {
        onError === null || onError === void 0 || onError(decisionStatus);
      }
    } catch (_unused) {
      // mutation failed; suggestion stays visible
      onError === null || onError === void 0 || onError(decisionStatus);
    } finally {
      setPendingDecision(null);
    }
  };
  const isLoading = pendingDecision !== null;
  return /*#__PURE__*/_jsxs(Flex, {
    children: [/*#__PURE__*/_jsx(Tooltip, {
      title: I18n.text('dealPlan.milestones.suggestion.approve'),
      children: /*#__PURE__*/_jsx(LoadingButton, {
        "data-test-id": "milestone-suggestion-approve",
        "aria-label": I18n.text('dealPlan.milestones.suggestion.approve'),
        failed: !!error,
        disabled: isLoading,
        loading: pendingDecision === 'APPROVED',
        onClick: () => {
          void handleDecision('APPROVED');
        },
        padding: "100",
        use: "tertiary-light",
        size: "xs",
        responsive: false,
        children: /*#__PURE__*/_jsx(SuccessIcon, {})
      })
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: I18n.text('dealPlan.milestones.suggestion.reject'),
      children: /*#__PURE__*/_jsx(LoadingButton, {
        "data-test-id": "milestone-suggestion-reject",
        "aria-label": I18n.text('dealPlan.milestones.suggestion.reject'),
        failed: !!error,
        disabled: isLoading,
        loading: pendingDecision === 'REJECTED',
        onClick: () => {
          void handleDecision('REJECTED');
        },
        padding: "100",
        use: "tertiary-light",
        size: "xs",
        responsive: false,
        children: /*#__PURE__*/_jsx(RemoveIcon, {})
      })
    })]
  });
}